import React from 'react';
import '../styles/App.css';
import supermanVideo from '../images/supermanVid.mp4';
import arrow from '../images/arrow.png';
import supermanGif from '../images/superman.gif';
import kawoLogo from '../images/KAWO-logo.png';


let tr = require( '../utils/translations' ).translate;


// MAIN REACT CLASS DECLARATION
// =================================================================================================
class SplashComponent extends React.Component {


	// REACT APP CONSTRUCTOR
	// =============================================================================================
	constructor( props ) {

		super( props );

		this.state = {
			videoPlaying: false
		};

		window.mixpanel.track( 'Pageview', {
			app: 'video-to-gif',
			action: 'welcome-page'
		} )
	}


	// MAIN RENDER METHOD
	// =============================================================================================
	render() {

		return (
			<div id="splashPanel">

				<div className="splash-container">

					<div className="splash-logo-container">

						<h3>动次</h3>

						<a target="_blank" href="http://www.kawo.com">
							<div className="splash-logo-inner">
								<small>{tr( 'made by', '技术提供' )}</small>
								<img src={kawoLogo}/>
							</div>
						</a>
					</div>

					<div className="main-container">

						<div className="media media-left" onClick={( e ) => this.playVideo( e )}>
							<video id="superman-video" loop muted src={supermanVideo}
								   onPause={( e ) => this.setState( prevState => ({ videoPlaying: false }) )}/>

							<div className={'video-controls' + ( this.state.videoPlaying ? ' video-controls-hidden' : '' )}/>
						</div>

						<div className="main-center">
							<img src={arrow}/>
						</div>

						<div className="media media-right">
							<img src={supermanGif}/>
						</div>

					</div>

					<article>

						<h3>{tr( 'The quickest and easiest way to convert videos to GIF\'s for Weibo and WeChat',
							'只需三步，飞速将视频转换为适合微博、微信发布的GIF图片' )}</h3>

						<div className="btn-group">
							<button className="btn btn-gold"
									onClick={( e ) => ( this.closeSplash( e ) )}>{tr( 'Get Started', '戳我，开始动次' )}
							</button>
						</div>

					</article>
				</div>
			</div>
		);
	}


	// =============================================================================================
	playVideo() {
		let video = document.getElementById( 'superman-video' );

		this.setState( prevState => ({
			videoPlaying: true
		}) );

		window.mixpanel.track( 'Welcome Page', {
			app: 'video-to-gif',
			action: 'video-played'
		} );

		video.play();
	}


	// =============================================================================================
	closeSplash( e ) {
		e.preventDefault();

		window.mixpanel.track( 'Welcome Page', {
			app: 'video-to-gif',
			action: 'close'
		} );

		try {
			localStorage.setItem( 'visited', true );
		} catch ( e ) {}

		this.props.App.setState( prevState => ({
			seenSplash: true
		}) );

		return false;
	}
}

export default SplashComponent;



// WEBPACK FOOTER //
// ./src/app/scenes/splash.js